import React from 'react';
import { Col, Row } from 'react-bootstrap';
import FilterPanel from '@spark/ui-components/components/FilterPanel';
import { filterConfig } from '../config/filterConfig';

const TagsOuvidoriaFilter = ({ loading, values, onApply, onLimpar }) => (
  <Row>
    <Col md={12}>
      <FilterPanel
        filters={filterConfig}
        values={values}
        onApply={onApply}
        onLimpar={onLimpar}
        title="Filtros de Tags da Ouvidoria"
        loading={loading}
        defaultCollapsed={true}
      />
    </Col>
  </Row>
);

export default TagsOuvidoriaFilter;
